module.exports = __webpack_public_path__ + "static/media/objects_04.9550e5b4.svg";